import { withNestedView } from '@/router/routerHelpers';
import { FEATURES } from '@/access/features';
import { PERMISSIONS } from '@/access/permissions';
const loadView = withNestedView('forms');

// Form permissions - user needs ANY of these to access forms
const formPermissions = [
  PERMISSIONS.MANAGE_FORMS,
  PERMISSIONS.VIEW_FORM_SUBMISSIONS,
  PERMISSIONS.CREATE_FORM_SUBMISSIONS,
];

const formsRoutes = [
  {
    path: '/forms',
    component: {
      render: (c) => c('router-view'),
    },
    meta: {
      feature: FEATURES.FORMS,
      permissions: formPermissions,
    },
    children: [
      {
        path: '',
        name: 'forms',
        props: true,
        component: loadView('FormCollections'),
        meta: {
          feature: FEATURES.FORMS,
          permissions: formPermissions,
        },
      },
      {
        path: 'collections/:collectionId',
        name: 'collection-detail',
        props: true,
        component: loadView('formCollections/CollectionDetail'),
        meta: {
          feature: FEATURES.FORMS,
          permissions: formPermissions,
        },
      },
      {
        path: ':formId',
        name: 'form-detail',
        props: true,
        component: loadView('forms/FormDetail'),
        meta: {
          feature: FEATURES.FORMS,
          permissions: formPermissions,
        },
      },
    ],
  },
];

export default formsRoutes;
